import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'

export const hasAutomaticAdminAccess = (userRoleType?: string) => userRoleType === 'super_admin'

type AccessSection = 'permissions' | 'groups' | 'customer' | 'transport'

const sectionMessages: Record<AccessSection, string> = {
  permissions: 'เข้าถึงทุกเมนูที่เปิดใช้งาน และทำรายการได้ครบทุกสิทธิ์โดยอัตโนมัติ ไม่ต้องกำหนดสิทธิ์รายเมนูเพิ่ม',
  groups: 'ได้รับสิทธิ์ทุกเมนูที่เปิดใช้งานโดยอัตโนมัติ ไม่ต้องเพิ่มกลุ่มผู้ใช้งานเพื่อรับสิทธิ์',
  customer: 'ดูข้อมูลวางบิลของทุกบริษัทลูกค้าในแฟรนไชส์ที่เลือกได้โดยอัตโนมัติ ไม่ต้องกำหนด Customer Scope เพิ่ม',
  transport: 'เข้าถึงข้อมูลขนส่งของทุกบริษัทขนส่งและคลังสินค้าได้โดยอัตโนมัติ ไม่ต้องกำหนด Transport Scope เพิ่ม',
}

export default function SuperAdminAccessPanel({ section }: { section: AccessSection }) {
  return (
    <Box p={3}>
      <Alert severity="info">
        บัญชีนี้เป็น Super Admin — {sectionMessages[section]}
        <br />
        การทำรายการยังเป็นไปตามเงื่อนไขของระบบ
      </Alert>
    </Box>
  )
}
